import { Component, Host, Prop, h } from '@stencil/core';
import svgIcon from '@abds/icons/dist/img/layout-module.svg';
import { FontSize, StrokeWidth } from '../../types';

/** @internal */
@Component({
  scoped: true,
  styleUrl: '../../../assets/styles/abds-icon-common.css',
  tag: 'abds-icon-layout-module',
})
export class IconLayoutModule {
  // --------------------------------------------------------------------------
  //
  //  Props
  //
  // --------------------------------------------------------------------------

  /**
   * The size of the icon, defaults to "base" icon dimensions follow typography
   * sizes defined in tailwind.typography.default.
   */
  @Prop({ reflect: true }) size: FontSize = 'base';

  /** the stroke width of the icon */
  @Prop({ reflect: true }) strokeWidth: StrokeWidth;

  // --------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  // --------------------------------------------------------------------------

  render() {
    return <Host class="internal-icon" innerHTML={svgIcon} size={this.size} stroke-width={this.strokeWidth} />;
  }
}
